import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export const LOCALITIES = [
  "Jayalakshmipuram", "Gokulam", "Vijayanagar", "Kuvempunagar", "Saraswathipuram", "Hebbal", "Nazarbad",
];

export const FilterBar = ({ filters, onChange, compact = false, hideListingType = false }) => {
  const upd = (k, v) => onChange({ ...filters, [k]: v === "any" ? "" : v });
  return (
    <div className={`${compact ? "flex flex-wrap gap-2" : "grid grid-cols-2 md:grid-cols-6 gap-3"}`} data-testid="filter-bar">
      <div className={compact ? "flex-1 min-w-[200px]" : "md:col-span-2"}>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--ink-muted)]" />
          <Input
            placeholder="Search by title or locality..."
            value={filters.q || ""}
            onChange={(e) => upd("q", e.target.value)}
            className="pl-9 bg-white"
            data-testid="filter-search-input"
          />
        </div>
      </div>
      {!hideListingType && (
        <Select value={filters.listing_type || "any"} onValueChange={(v) => upd("listing_type", v)}>
          <SelectTrigger data-testid="filter-listing-type"><SelectValue placeholder="Buy or Rent" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="any">Buy &amp; Rent</SelectItem>
            <SelectItem value="buy" data-testid="opt-buy">For Sale</SelectItem>
            <SelectItem value="rent" data-testid="opt-rent">For Rent</SelectItem>
          </SelectContent>
        </Select>
      )}
      <Select value={filters.locality || "any"} onValueChange={(v) => upd("locality", v)}>
        <SelectTrigger data-testid="filter-locality"><SelectValue placeholder="Locality" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="any">All Mysuru</SelectItem>
          {LOCALITIES.map((l) => (
            <SelectItem key={l} value={l} data-testid={`locality-${l}`}>{l}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={filters.property_type || "any"} onValueChange={(v) => upd("property_type", v)}>
        <SelectTrigger data-testid="filter-property-type"><SelectValue placeholder="Property Type" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="any">Any Type</SelectItem>
          <SelectItem value="villa">Villa</SelectItem>
          <SelectItem value="apartment">Apartment</SelectItem>
          <SelectItem value="heritage">Heritage Home</SelectItem>
          <SelectItem value="independent_house">Independent House</SelectItem>
          <SelectItem value="plot">Plot / Site</SelectItem>
        </SelectContent>
      </Select>
      <Select value={filters.bhk ? String(filters.bhk) : "any"} onValueChange={(v) => upd("bhk", v === "any" ? "" : Number(v))}>
        <SelectTrigger data-testid="filter-bhk"><SelectValue placeholder="BHK" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="any">Any BHK</SelectItem>
          <SelectItem value="1">1 BHK</SelectItem>
          <SelectItem value="2">2 BHK</SelectItem>
          <SelectItem value="3">3 BHK</SelectItem>
          <SelectItem value="4">4+ BHK</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
